import { context, TradeState } from '../../../_shared/types/trade';

/**
 * This hook is responsible for mapping if the VDP page is available for the current context and trade state.
 * @param tradeDetails
 * @param tradeContext
 * @param user
 */
const isWeb5VdpEnabled = (tradeDetails, tradeContext, user): Boolean => {
  const isSelling = tradeContext === context.selling;

  /**
   * If `tradeDetails` is not provided, it will use the value stored in the Redux State
   */
  const { tradeState, dealer } = tradeDetails || {};

  const mapVdpStatesAvailableByContext = {
    [context.buying]: [
      TradeState.active,
      TradeState.upcoming,
      TradeState.pending,
      TradeState.closing
    ],
    [context.selling]: [TradeState.pending, TradeState.closing]
  };

  const pendingClosingStates: TradeState[] = [];
  pendingClosingStates.push(TradeState.closing);

  // If feature flag is not available, remove them from the constant.
  mapVdpStatesAvailableByContext[
    context.buying
  ] = mapVdpStatesAvailableByContext[context.buying].filter(
    state => !pendingClosingStates.includes(state)
  );

  mapVdpStatesAvailableByContext[
    context.selling
  ] = mapVdpStatesAvailableByContext[context.selling].filter(
    state => !pendingClosingStates.includes(state)
  );

  let mapContext = context.buying;
  if (isSelling || dealer?.id === user?.dealerId) {
    mapContext = context.selling;
  }

  const mapStatesAvailable = mapVdpStatesAvailableByContext[mapContext] || [];

  return mapStatesAvailable.includes(tradeState);
};

export default isWeb5VdpEnabled;
